import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueMeta from 'vue-meta'
import VueAnalytics from 'vue-analytics'

import "./assets/styles/quinielazo.css";
import "@/assets/styles/general.css";

import QuinielazoService from "@/services/QuinielazoService";

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";

import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons/faCalendarAlt";
import { faUsers } from "@fortawesome/free-solid-svg-icons/faUsers";
import { faCheckSquare } from "@fortawesome/free-solid-svg-icons/faCheckSquare";
import { faTrophy } from "@fortawesome/free-solid-svg-icons/faTrophy";
import { faChartBar } from "@fortawesome/free-solid-svg-icons/faChartBar";
import { faUser } from "@fortawesome/free-solid-svg-icons/faUser";
import { faFileAlt } from "@fortawesome/free-solid-svg-icons/faFileAlt";
import { faCoins } from "@fortawesome/free-solid-svg-icons/faCoins";
import { faFutbol } from "@fortawesome/free-solid-svg-icons/faFutbol";
import { faPlayCircle } from "@fortawesome/free-solid-svg-icons/faPlayCircle";
import { faChartPie } from "@fortawesome/free-solid-svg-icons/faChartPie";
import { faLock } from "@fortawesome/free-solid-svg-icons/faLock";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons/faEnvelope";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons/faInfoCircle";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons/faExclamationCircle";
import { faDollarSign } from "@fortawesome/free-solid-svg-icons/faDollarSign";
import { faMoneyBillAlt } from "@fortawesome/free-solid-svg-icons/faMoneyBillAlt";
import { faCheck } from "@fortawesome/free-solid-svg-icons/faCheck";
import { faFile } from "@fortawesome/free-solid-svg-icons/faFile";
import { faShareAlt } from "@fortawesome/free-solid-svg-icons/faShareAlt";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons/faArrowLeft";
import { faBell } from "@fortawesome/free-solid-svg-icons/faBell";
import { faGlobeAmericas } from "@fortawesome/free-solid-svg-icons/faGlobeAmericas";
import { faRss } from "@fortawesome/free-solid-svg-icons/faRss";
import { faHome } from "@fortawesome/free-solid-svg-icons/faHome";
import { faClock } from "@fortawesome/free-solid-svg-icons/faClock";
import { faImage } from "@fortawesome/free-solid-svg-icons/faImage";
import { faBars } from "@fortawesome/free-solid-svg-icons/faBars";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons/faQuestionCircle";
import { faCog } from "@fortawesome/free-solid-svg-icons/faCog";
import { faBookOpen } from "@fortawesome/free-solid-svg-icons/faBookOpen";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons/faTimesCircle";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons/faPaperPlane";
import { faHandshake } from "@fortawesome/free-solid-svg-icons/faHandshake";
import { faKey } from "@fortawesome/free-solid-svg-icons/faKey";
import { faSearch } from "@fortawesome/free-solid-svg-icons/faSearch";

import { faFacebookSquare } from "@fortawesome/free-brands-svg-icons/faFacebookSquare";
import {faTwitterSquare} from "@fortawesome/free-brands-svg-icons/faTwitterSquare";
import {faGoogle} from "@fortawesome/free-brands-svg-icons/faGoogle";
import { faTwitter } from "@fortawesome/free-brands-svg-icons/faTwitter";
import {faFacebookF} from "@fortawesome/free-brands-svg-icons/faFacebookF";
import {faWhatsapp } from "@fortawesome/free-brands-svg-icons/faWhatsapp";

//Add icons to the library
library.add(
  faCalendarAlt,
  faUsers,
  faCheckSquare,
  faTrophy,
  faChartBar,
  faUser,
  faFileAlt,
  faFacebookSquare,
  faTwitterSquare,
  faGoogle,
  faFacebookF,
  faWhatsapp,
  faCoins,
  faFutbol,
  faPlayCircle,
  faChartPie,
  faLock,
  faEnvelope,
  faInfoCircle,
  faExclamationCircle,
  faDollarSign,
  faMoneyBillAlt,
  faCheck,
  faFile,
  faShareAlt,
  faArrowLeft,
  faBell,
  faGlobeAmericas,
  faRss,
  faHome,
  faClock,
  faImage,
  faBars,
  faQuestionCircle,
  faCog,
  faBookOpen,
  faTimesCircle,
  faPaperPlane,
  faHandshake,
  faKey,
  faTwitter,
  faSearch
  );
  
  import * as timeago from "timeago.js";
  import es from "timeago.js/esm/lang/es";
  import "./registerServiceWorker";
  
  Vue.prototype.$timeago = timeago;
  
  Vue.config.productionTip = false;
  
  Vue.component("font-awesome-icon", FontAwesomeIcon);
  
  Vue.prototype.$cdn = "https://quinielazo.s3-us-west-1.amazonaws.com/";
  Vue.use(VueMeta);
  Vue.use(VueAnalytics,{
    id: 'UA-29629113-1',
    router
  });

new Vue({
  router,
  store,
  beforeCreate() {
    //Automatic login if token exist on localStorage
    const userString = localStorage.getItem("user");

    if (userString) {
      const userData = JSON.parse(userString);
      store.commit("user/SET_USER", userData);
    }

    //Logout when unauthorized errors
    QuinielazoService.getAxiosObject().interceptors.response.use(
      response => response,
      error => {
        if (error.response.status === 440) {
          store.dispatch("logout");
        }
        return Promise.reject(error);
      }
    );
  },
  created() {
    this.$timeago.register("es", es);
  },
  render: h => h(App)
}).$mount("#app");
